import { OnInit } from '@angular/core';
import { LoginService } from './services/login.service';
import { Globals } from './objects/Globals';
import { TokenManager } from './Globals';
import { Router } from '@angular/router';
import { ToasterService, ToasterConfig, BodyOutputType } from 'angular2-toaster';
import { ThemeSettingService } from './services/theme-setting.service';
import { ngxLoadingAnimationTypes } from 'ngx-loading';
import { HeaderService } from './services/header.service';
import { Observable, fromEvent, of, merge } from 'rxjs';
import { mapTo } from 'rxjs/operators';
import { enableProdMode } from '@angular/core';
import { ConfirmationService } from './services/confirmation.service';
import { BsModalService } from 'ngx-bootstrap';
import { MainLoadingService } from './services/main-loading.service';
import { ToasterMessageService } from './services/toaster-message.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { DeviceType } from './objects/DeviceInfoObject';
import { EnvService } from './env.service';
import { Title } from '@angular/platform-browser';
import { SessionTimerService } from './services/session-timer.service';
import { SidePopupService } from './services/side-popup.service';
enableProdMode();
var AppComponent = /** @class */ (function () {
    function AppComponent(loginService, globals, tokenManager, router, toasterService, themeSettingService, headerService, confirmationService, modalService, mainLoadingService, toasterMessageService, deviceService, env, title, sessionTimerService, sidePopupService) {
        var _this = this;
        this.loginService = loginService;
        this.globals = globals;
        this.tokenManager = tokenManager;
        this.router = router;
        this.themeSettingService = themeSettingService;
        this.headerService = headerService;
        this.confirmationService = confirmationService;
        this.modalService = modalService;
        this.mainLoadingService = mainLoadingService;
        this.toasterMessageService = toasterMessageService;
        this.deviceService = deviceService;
        this.env = env;
        this.title = title;
        this.sessionTimerService = sessionTimerService;
        this.sidePopupService = sidePopupService;
        this.errorCount = 0;
        this.isBusy = false;
        this.deviceInfo = null;
        this.tabsArray = [];
        this.showBackdrop = false;
        this.slideIn = false;
        this.config = new ToasterConfig({
            animation: 'fade',
            timeout: 5000,
            tapToDismiss: false,
            mouseoverTimerStop: true
        });
        this.getColor();
        this.checkDevice();
        this.sidePopupService.currentPopupChanged$.subscribe(function (result) {
            if (result) {
                _this.detailId = result;
                _this.slideIn = true;
            }
            else {
                _this.slideIn = false;
            }
        });
        this.toasterService = toasterService;
        this.online$ = merge(of(navigator.onLine), fromEvent(window, 'online').pipe(mapTo(true)), fromEvent(window, 'offline').pipe(mapTo(false)));
        this.loginService.online$.subscribe(function (online) {
            _this.online = online;
            if (_this.online && _this.sub) {
                if (_this.sub.closed) {
                    var timer = Observable.timer(1000, 10000);
                    _this.sub = timer.subscribe(function (t) { return _this.checkSession(); });
                    _this.toasterService.clear(_this.toast.toastId, _this.toast.toastContainerId);
                    document.querySelectorAll(".backdrop").item(0).classList.remove("main-backdrop");
                }
            }
        });
        router.events.subscribe(function (event) {
            title.setTitle(_this.env.portalTab);
            if (router.url == "/login" || router.url == "/" || router.url == "/supplier-registration" || router.url.indexOf("/onetimeaction") > -1 || router.url.indexOf("/resetpassword") > -1) {
                _this.isDefault = true;
            }
            else {
                _this.isDefault = false;
            }
            if (router.url == "/faq" || router.url == "/contact-us" || router.url == "/vendor-applications") {
                _this.hasBackground = true;
            }
            else {
                _this.hasBackground = false;
            }
        });
        headerService.isSessionAliveChanged$.subscribe(function (result) {
            _this.isSessionAlive = result;
        });
        this.mainLoadingService.mainLoadingChanged$.subscribe(function (value) {
            if (value) {
                _this.isBusy = true;
            }
            else {
                _this.isBusy = false;
            }
        });
        this.mainLoadingService.progressBarChanged$.subscribe(function (value) {
            _this.isProgressing = value;
        });
    }
    AppComponent.prototype.getColor = function () {
        this.primaryColour = this.env.primaryColor;
        this.secColor = this.env.secondaryColor;
        this.accentColor = this.env.accentColor;
        this.baseColor = this.env.baseColor;
        this.iconColor = this.env.iconColor;
    };
    AppComponent.prototype.ngOnInit = function () {
        var _this = this;
        var timer = Observable.timer(1000, 10000);
        this.sub = timer.subscribe(function (t) { return _this.checkSession(); });
        var colors = new Map([
            ['primary', this.primaryColour],
            ['secondary', this.secColor],
            ['accent', this.accentColor],
            ['base', this.baseColor],
            ['icon', this.iconColor]
        ]);
        Array.from(colors.entries()).forEach(function (_a) {
            var name = _a[0], value = _a[1];
            document.body.style.setProperty("--" + name, value);
        });
        this.themeSettingService.setTheme({
            animationType: ngxLoadingAnimationTypes.threeBounce,
            backdropBackgroundColour: 'rgba(255, 255, 255,0.2)',
            backdropBorderRadius: '10px',
            primaryColour: this.primaryColour,
            secondaryColour: this.primaryColour,
            tertiaryColour: this.primaryColour,
            accentColour: this.accentColor
        });
        this.headerService.displayMenu(true);
        this.loaderConfig = this.themeSettingService.getTheme();
    };
    AppComponent.prototype.changeColour = function () {
        var theme = this.randomTheme();
        this.primaryColour = theme.primary;
        this.secColor = theme.secondary;
        this.accentColor = theme.accent;
        document.body.style.setProperty("--primary", this.primaryColour);
        document.body.style.setProperty("--secondary", this.secColor);
        document.body.style.setProperty("--accent", this.accentColor);
        document.body.style.setProperty("--base", this.baseColor);
    };
    AppComponent.prototype.randomTheme = function () {
        var primary = this.randomHex();
        var secondary = this.randomHex();
        var accent = this.randomHex();
        return { primary: primary, secondary: secondary, accent: accent };
    };
    AppComponent.prototype.randomHex = function () {
        return '#' + Math.floor(Math.random() * 16777215).toString(16);
    };
    AppComponent.prototype.checkSession = function () {
        var _this = this;
        if (this.online) {
            var sessionCookie = JSON.parse(this.tokenManager.retrieve("BRNSessionKey"));
            if (sessionCookie && this.errorCount < 5) {
                this.loginService.getSession(sessionCookie).subscribe(function (result) {
                    if (result) {
                        var checkSessionObject = JSON.parse(result);
                        if (checkSessionObject.StatusCode != 200) {
                            if (_this.currentMessage == checkSessionObject.StatusMessage) {
                                _this.errorCount++;
                            }
                            else {
                                _this.errorCount = 0;
                            }
                            if (_this.currentMessage != checkSessionObject.StatusMessage) {
                                _this.currentMessage = checkSessionObject.StatusMessage;
                                if (_this.isSessionAlive) {
                                    _this.popToast("Warning", checkSessionObject.StatusMessage, "warning", 0);
                                    _this.headerService.setSessionAlive(false);
                                }
                            }
                            _this.tokenManager.store("BRNSessionKey", null);
                            _this.loginService.setSession(null);
                            _this.sessionTimerService.stopSessionTimer();
                            setTimeout(function () {
                                _this.isBusy = false;
                                _this.globals.Session = null;
                                _this.router.navigate(['/login']);
                            }, 5000);
                            // hides all the modals
                            _this.hidesAllModals();
                        }
                        if (checkSessionObject.SessionObject) {
                            var sessionObject = checkSessionObject.SessionObject;
                            _this.loginService.setSession(sessionObject);
                        }
                    }
                    else {
                        _this.sessionTimerService.stopSessionTimer();
                        _this.tokenManager.store("BRNSessionKey", null);
                        _this.popToast("Warning", "You have been logged out. Somebody has logged into your account from another device.", "warning", 0);
                        _this.loginService.setSession(null);
                        setTimeout(function () {
                            _this.globals.Session = null;
                            _this.router.navigate(['/login']);
                        }, 5000);
                        // hides all the modals
                        _this.hidesAllModals();
                    }
                }, function (error) {
                    if (error.status == 0) {
                        _this.loginService.setSession(null);
                    }
                });
            }
            else {
                if (this.router.url != '/supplier-registration') {
                    this.loginService.setSession(null);
                }
            }
        }
        else {
            if (this.globals.Session) {
                this.popToast("Connection is lost", "There seems to be a problem connecting to the server, please contact system administrator accordingly", "error", 0);
                document.querySelectorAll(".backdrop").item(0).classList.add("main-backdrop");
                this.loginService.setSession(null);
            }
            this.sub.unsubscribe();
        }
    };
    AppComponent.prototype.hidesAllModals = function () {
        if (this.confirmationService.bsModalRef) {
            this.confirmationService.bsModalRef.hide();
        }
        for (var i = 1; i <= this.modalService.getModalsCount(); i++) {
            this.modalService.hide(i);
        }
        document.body.classList.remove('modal-open');
        this.sidePopupService.removePopup();
    };
    AppComponent.prototype.popToast = function (title, body, type, timeout) {
        this.toast = {
            type: type,
            title: title,
            body: body,
            showCloseButton: true,
            timeout: timeout,
            bodyOutputType: BodyOutputType.TrustedHtml,
            onHideCallback: function (toast) {
                // document.querySelectorAll(".backdrop").item(0).classList.remove("main-backdrop");
            }
        };
        //var toasterObj = this.toasterMessageService.getToaster()
        this.toasterService.pop(this.toast);
    };
    AppComponent.prototype.checkDevice = function () {
        var deviceType;
        this.deviceInfo = this.deviceService.getDeviceInfo();
        var isMobile = this.deviceService.isMobile(); // returns if the device is a mobile device (android / iPhone / windows-phone etc)
        var isTablet = this.deviceService.isTablet(); // returns if the device us a tablet (iPad etc)
        var isDesktopDevice = this.deviceService.isDesktop(); // returns if the app is running on a Desktop browser.
        if (isMobile) {
            deviceType = DeviceType.MOBILE;
        }
        else if (isTablet) {
            deviceType = DeviceType.TABLET;
        }
        else if (isDesktopDevice) {
            deviceType = DeviceType.DESKTOP;
        }
        this.device = {
            deviceInfo: this.deviceInfo,
            isMobile: isMobile,
            isTablet: isTablet,
            isDekstop: isDesktopDevice,
            deviceType: deviceType
        };
        this.loginService.setDeviceInfo(isMobile);
        // console.log(this.device);
    };
    AppComponent.prototype.activeTabs = function (isActive) {
        if (isActive == 'active') {
            this.showBackdrop = true;
        }
        else {
            this.showBackdrop = false;
        }
    };
    AppComponent.prototype.hide = function () {
        this.slideIn = false;
        this.sidePopupService.removePopup();
    };
    return AppComponent;
}());
export { AppComponent };
